module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_ja-f79dd6fb3e6a15ff34249c0bcaed320c.jpg";